import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Provider as StoreProvider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import { withRouter, Route } from 'react-router'
import 'utils/mobileApp'
import { MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { AppProgressIndicator } from 'atoms/AppProgress'
import { AppSnackbar } from 'atoms/AppSnackbar'
import Routes from './pages'

@withRouter
class ScrollToTop extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    children: PropTypes.any
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props
    const { scrollToTop } = location.state || {}
    if (location !== prevProps.location && scrollToTop !== false) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { children } = this.props
    return children
  }
}

const App = ({ store, theme, history }) => (
  <StoreProvider store={store}>
    <ConnectedRouter history={history}>
      <ScrollToTop>
        <MuiThemeProvider theme={theme}>
          <Fragment>
            <CssBaseline />
            <AppProgressIndicator />
            <AppSnackbar />
            <Route component={Routes} />
          </Fragment>
        </MuiThemeProvider>
      </ScrollToTop>
    </ConnectedRouter>
  </StoreProvider>
)

App.propTypes = {
  store: PropTypes.any.isRequired,
  theme: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired,
}

export default App
